import { InjectionToken } from '@angular/core';

import { Observable } from 'rxjs';

import { GetMetricsReq, GetMetricsRes, GetTransactionsReq, GetTransactionsRes } from '../models';

export interface TransactionsApi {
  getMetrics(params: GetMetricsReq): Observable<GetMetricsRes>;
  getTransactions(params: GetTransactionsReq): Observable<GetTransactionsRes>;
}

export const TRANSACTIONS_API = new InjectionToken<TransactionsApi>('TRANSACTIONS_API');
